import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=6378d12c&scoped=true&"
import script from "./Alert.vue?vue&type=script&lang=js&"
export * from "./Alert.vue?vue&type=script&lang=js&"
import style0 from "./Alert.vue?vue&type=style&index=0&id=6378d12c&prod&lange=scsss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6378d12c",
  null
  
)

export default component.exports